import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AccountService} from "../../../../service/api/account.service";
import {MessageToastService} from "../../../../service/message-toast.service";
import {finalize, tap} from "rxjs";
import {ApiResponse} from "../../../../shared/model/response/ApiResponse";
import {AccountResponse} from "../../../../shared/model/response/account-response.model";
import {ErrorMessageEnum} from "../../../../shared/enums/error-message.enum";

@Component({
    selector: 'app-add-phone-number',
    templateUrl: './add-phone-number.component.html',
    standalone: false
})
export class AddPhoneNumberComponent implements OnInit {

  @Input('account') account: AccountResponse;

  @Output('onCloseModal') onCloseModal = new EventEmitter<AccountResponse>();

  form: FormGroup;
  formErrors: Map<string, string> = new Map();

  isLoadingPhoneNumberValCodeReq = false;
  isLoadingPhoneNumberAdd = false;

  constructor(
    private accountService: AccountService,
    private toastService: MessageToastService
  ) {
  }

  ngOnInit(): void {
    this.initForm()
  }

  initForm(): void {
    this.form = new FormGroup({
      "phoneNumber": new FormControl(null, [Validators.required, Validators.pattern(/^\d{9}$/)]),
      "phoneValidationCode": new FormControl(null, Validators.required),
    });

  }

  apiRequestPhoneNumberCode() {
    this.formErrors?.clear()
    const phone = this.form.get("phoneNumber")
    if (phone?.hasError("required")) {
      this.formErrors.set("phoneNumber", ErrorMessageEnum.requiredField)
      return
    }
    if (phone?.hasError("pattern")) {
      this.formErrors.set("phoneNumber", ErrorMessageEnum.invalidPhone)
      return
    }
    this.isLoadingPhoneNumberValCodeReq = true
    this.accountService.validatePhoneNumber(this.form.get("phoneNumber")?.value)
      .pipe(finalize(() => this.isLoadingPhoneNumberValCodeReq = false),
        tap({
          next: (response) => this.toastService.success(response.message),
          error: (response: ApiResponse<any>) => {
            this.toastService.error(response.message)
            this.formErrors = response?.formErrors ?? new Map()
          }
        }))
      .subscribe()
  }

  apiAddPhoneNumber() {
    this.formErrors?.clear()
    this.isLoadingPhoneNumberAdd = true
    this.accountService.addPhoneNumber(this.form.value)
      .pipe(
        finalize(() => this.isLoadingPhoneNumberAdd = false),
        tap({
            next: (response) => {
              this.onCloseModal.emit(response.data)
              this.toastService.success(response.message)
            },
            error: (err: ApiResponse<any>) => {
              this.formErrors = err?.formErrors ?? new Map()
              this.toastService.error(err.message)
            }
          }
        )
      )
      .subscribe()
  }
}
